// Composables
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import HomeView from "@/views/HomeView.vue";
import TourView from "@/views/tours/TourView.vue";
import ToursView from "@/views/tours/ToursView.vue";
import DonesView from "@/views/done/DonesView.vue";
import OrderCreate from "@/views/orders/OrderCreate.vue";
import DoneView from "@/views/done/DoneView.vue";
import OrderView from "@/views/orders/OrderView.vue";
import ProfileView from "@/views/ProfileView.vue";
import LicensePlateView from "@/views/LicensePlateView.vue";
import TermsView from "@/views/TermsView.vue";
import ResetPasswordView from "@/views/ResetPasswordView.vue";

export default [
  {
    path: "/",
    component: DefaultLayout,
    children: [
      {
        path: "",
        name: "assignments",
        component: HomeView,
      },
      {
        path: "/assignments/:id/:position/:direction",
        name: "assignment-view",
        component: OrderView,
      },
      {
        path: "/tour",
        name: "tour",
        component: ToursView,
      },
      {
        path: "/tour/:id/:position/:direction",
        name: "tour-view",
        component: TourView,
      },
      {
        path: "/done",
        name: "done",
        component: DonesView,
      },
      {
        path: "/done/:id/:position/:direction",
        name: "done-view",
        component: DoneView,
      },
      {
        path: "/profile",
        name: "profile",
        component: ProfileView,
      },
      {
        path: "/reset-password",
        name: "reset-password",
        component: ResetPasswordView,
      },
      {
        path: "/license-plate",
        name: "license-plate",
        component: LicensePlateView,
      },
      {
        path: "/link-1",
        name: "link-1",
        component: HomeView,
      },
      {
        path: "/link-2",
        name: "link-2",
        component: HomeView,
      },
      {
        path: "/link-3",
        name: "link-3",
        component: HomeView,
      },
      {
        path: "/orders/create",
        name: "order-create",
        component: OrderCreate,
      },
      {
        path: "acceptTerms",
        name: "acceptTerms",
        component: TermsView,
      },
    ],
  },
];
